/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscrepancyResponse } from '../../models/article-discrepancy-response';
import { KeyType } from '../../models/key-type';
import { PartialArticleDiscrepancyRequest } from '../../models/partial-article-discrepancy-request';

export interface PatchArticleDiscrepancy$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  discrepancyKey: KeyType;
  articleKey: KeyType;
      body: PartialArticleDiscrepancyRequest
}

export function patchArticleDiscrepancy(http: HttpClient, rootUrl: string, params: PatchArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepancyResponse>> {
  const rb = new RequestBuilder(rootUrl, patchArticleDiscrepancy.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('discrepancyKey', params.discrepancyKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleDiscrepancyResponse>;
    })
  );
}

patchArticleDiscrepancy.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies/{discrepancyKey}';
